import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useParams } from 'react-router-dom';
import MainLayout from '../../layouts/MainLayout';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faQrcode, faList, faListUl } from '@fortawesome/free-solid-svg-icons';
import './ConnectFive.css';
import connectfiveimage from '../../assets/pageimages/ConnectFive.webp';

function ConnectFiveHome() {

  return (
    <MainLayout>
      <div>
        <h2 className='text-lg mt-1 mx-8 border-b border-b-gray-300 text-white'>ConnectFive (RMS)</h2>
      </div>
      <div className="main-content">
        <div className="top-section top-section mt-4 ml-2 mr-0 border border-b-gray-300">
            <div className="button-links flex align-middle justify-center bg-gray-500">
              <div className="bottom-buttons-box"><Link to="/connectfive-itemlist" className="top-button-link"><FontAwesomeIcon icon={faList} className="connectfive-bottomlink-style" />My Messages</Link></div>
              <div className="bottom-buttons-box"><Link to="/connectfive-createcode" className="top-button-link"><FontAwesomeIcon icon={faQrcode} className="connectfive-bottomlink-style" />Messages To Me</Link></div>
          </div>
        </div>
        <div className="image-container">
        <div className="relative inset-0 flex border border-b-gray-300">
            <img id="connectfive-id" src={connectfiveimage} alt="ConnectFive Image" />
          </div>
        </div>
      </div>
    </MainLayout>
  );
}

export default ConnectFiveHome;
